module.exports = __webpack_public_path__ + "static/media/index-cover.56585563.png";